export const notificationColumns = {
  'MANAGE NOTIFICATIONS' : [
    {id: 'notificationName', label: 'Notification Name', width: "35rem" , align: 'left'},
    {id: 'action', label: 'On/Off', width: "10rem" , align: 'left'},
    {id: 'optionalEmails', label: "Notification sent to optional Email(s)", width: "51rem" ,align: "left"},
    {id: 'action', label: 'Actions', width: "5rem" , align: 'left'}
  ]
}